import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';

export const PanelCopyLinkMenuItem = ({onSelect}: {onSelect: () => void}) => {
  return (
    <DropdownMenu.Item onSelect={onSelect}>
      <Icon name="link-alt" />
      Copy panel URL
    </DropdownMenu.Item>
  );
};
